// extracted by mini-css-extract-plugin
module.exports = {"VerifiedEmail":"VerifiedEmail_VerifiedEmail__1oRO1","MiddleCenter":"VerifiedEmail_MiddleCenter__1tUqB"};